/* eslint-disable */
export default {
  noResultFoundFor: 'Kein Ergebnis gefunden für',
  search: 'Suchen',
} as const;

// @key: @#@"noResultFoundFor"@#@ @source: @#@"No result found for"@#@
// @key: @#@"search"@#@ @source: @#@"Search"@#@
